import { render, staticRenderFns } from "./TariffItemsGrid.vue?vue&type=template&id=0be2bf7e"
import script from "./TariffItemsGrid.vue?vue&type=script&lang=js"
export * from "./TariffItemsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports